import styled from 'styled-components';
export const Wrap = styled.div`
  width: 100%;
  overflow: hidden;

  --swiper-pagination-color: #222;
  --swiper-pagination-left: auto;
  --swiper-pagination-right: 8px;
  --swiper-pagination-bottom: 8px;
  --swiper-pagination-top: auto;
  --swiper-pagination-bullet-size: 5px;
  --swiper-pagination-bullet-width: 5px;
  --swiper-pagination-bullet-height: 5px;
  --swiper-pagination-bullet-inactive-color: #222;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 0.5;
  --swiper-pagination-bullet-horizontal-gap: 5px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  //aspect-ratio: 348 / 148;
  cursor: pointer;

  img {
    object-fit: contain;
    max-width: 100%;
    vertical-align: top;
    //max-height: 100%;
    //aspect-ratio: 348 / 148;
  }
`;
